<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog title="添加分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="form.parent_id">
          <el-option label="顶级分类" value="0"></el-option>
          <el-option :value="cat.category_id" :label="cat.name" :key="cat.category_id" v-for="cat in addform.catList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="分类图片" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类图片小图" prop="image_id_1" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload1">选择图片</el-button>
          <div v-if="form.image_id_1!=''" class="img">
            <img :src="file_path_1" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Upload v-if="isupload1" :isupload="isupload1" :type="type1" @returnImgs="returnImgsFunc1">上传图片</Upload>
  </el-dialog>

</template>

<script>
  import NotesApi from '@/api/notes.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          parent_id: '0',
          name: '',
          sort: 100,
          image_id: '',
          image_id_1: ''
        },
        formRules: {
          name: [{
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }],
          image_id: [{
            required: true,
            message: '请上传分类图片',
            trigger: 'blur'
          }],
          // image_id_1: [{
          //   required: true,
          //   message: '请上传分类小图图片',
          //   trigger: 'blur'
          // }],
          sort: [{
            required: true,
            message: '分类排序不能为空'
          }, {
            type: 'number',
            message: '分类排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
        isupload1: false,
        file_path_1:'',
      };
    },
    props: ['open_add', 'addform'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加用户*/
      addUser() {
        let self = this;
        let params = self.form;
        // console.log(params);return;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            NotesApi.catAdd(params).then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*上传小图*/
      openUpload1(e) {
        this.type1 = e;
        this.isupload1 = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      /*获取图片*/
      returnImgsFunc1(e) {
        if (e != null && e.length > 0) {
          this.file_path_1 = e[0].file_path;
          this.form.image_id_1 = e[0].file_id;
        }
        // console.log(this.file_path_1);
        this.isupload1 = false;
      },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/category/Add.vue